import { useEffect, useRef, useState } from 'react'
import { CoursesManangementVM } from '../../../Structure/ViewModels/Admin/CoursesManagementVM'

const SimpleCustomizingList = (props:{vm:CoursesManangementVM,list :{id:string , value:string}[] , dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'}) => {
    const [vm , setVm] = useState<{viewModel:CoursesManangementVM}>({viewModel:props.vm})
    const control = vm.viewModel
    useEffect(()=>control.subscribeUpdate(setVm),[])
    
    const [value , setValue] = useState<string>('')
    const [deleting , setDeleting] = useState<string|null>(null)

    const addingButtonRef = useRef<HTMLDivElement>(null)
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>)=>{
        if(event.key === 'Enter' && addingButtonRef.current){
            addingButtonRef.current.click()
        }
    }


    return (
        <div className='h-100 d-flex flex-column justify-content-between p-2' style={{background:'rgba(240,240,240)'}}>
            <div className='d-flex flex-wrap py-3 justify-content-start  txt-color-I overflow-y-auto'>
            {
                deleting?
                (
                    <div className='w-100 py-3 d-flex justify-content-center flex-wrap' style={{background:'rgba(240,240,240,1)'}}>
                    <div className='d-flex justify-content-center'>
                        هل تريد حذف {props.dataType} ؟
                    </div>
                    <div className={`material-symbols-outlined px-3 text-success c-pointer`} onClick={()=>{ control.delete(deleting , props.dataType);setDeleting(null) }}>
                        check
                    </div>
                    <div className='material-symbols-outlined px-3 text-danger c-pointer' onClick={()=>setDeleting(null) }>
                        close
                    </div>
                </div>
                ):
                props.list.map((item,index)=>(
                    <div key={index} className='py-1 mx-2 my-1 bill-tab bill-III d-flex justify-content-between' >
                        <div className='px-3 my-auto'>
                            {item.value} 
                        </div>
                        <div className='material-symbols-outlined px-2 my-auto fs-6 c-pointer danger-item' onClick={()=>setDeleting(item.id ) }>
                            delete
                        </div>
                    </div>
                ))
            }
            </div>
            <div className='d-flex pt-3 px-2'>
                <div className='d-flex w-100'>
                    <input type="text" className='input-field w-100' value={value} onChange={a=>setValue(a.target.value)} onKeyDown={handleKeyDown} />
                </div>
                <div className='d-flex pe-3'>
                   <div ref={addingButtonRef} className={`material-symbols-outlined success-item c-pointer m-auto fs-3 px-2`} onClick={()=>{ control.addItem(value,props.dataType); setValue('') }}>add</div> 
                </div>
            </div>
        </div>
    )
}

export default SimpleCustomizingList
